import { motion } from 'framer-motion';
import { BUSINESS_INFO } from '../../constants';
import { dispararConversaoWhatsApp } from '../../utils/gtag';
import './notfound.scss';

export default function NotFound() {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleWhatsApp = () => {
    dispararConversaoWhatsApp(() => {
      window.open(BUSINESS_INFO.whatsappUrl, '_blank', 'noopener,noreferrer');
    });
  };

  return (
    <section className="notfound">
      <div className="notfound-container">
        <motion.div 
          className="notfound-background"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="notfound-number">404</h1>
        </motion.div>
        
        <motion.div 
          className="notfound-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="notfound-icon">
            <i className="ri-error-warning-line"></i>
          </div>
          
          <h2 className="notfound-title">Página Não Encontrada</h2>
          
          <p className="notfound-description">
            Ops! A página que você está procurando não existe ou foi movida.
          </p>

          <div className="notfound-actions">
            <button onClick={handleGoHome} className="btn-home">
              <i className="ri-home-line"></i>
              Voltar ao Início
            </button>
            
            <button onClick={handleWhatsApp} className="btn-contact">
              <i className="ri-whatsapp-line"></i>
              Falar Conosco
            </button>
          </div>

          <div className="notfound-links">
            <p>Links úteis:</p>
            <div className="quick-links">
              <a href="/#servicos">
                <i className="ri-washing-machine-line"></i>
                Serviços
              </a>
              <a href="/#localizacao">
                <i className="ri-map-pin-line"></i>
                Localização
              </a>
              <a href="/#avaliacoes">
                <i className="ri-star-line"></i>
                Avaliações
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
